import { useRef } from 'react';

import { Typography } from '@ui/uikit/components/common/Typography';

import type { AdjacentRound } from '../../../../model/AdjacentRound/adjacentRound';
import { isPredictionRoundEnded } from '../../../../model/AdjacentRound/roundState';
import { PredictionCountDown } from '../PredictionCountDown/PredictionCountDown';

type NextDrawCounterProps = {
  round?: AdjacentRound;
  isLoading: boolean;
};

export const NextRoundCounter = ({ round, isLoading }: NextDrawCounterProps) => {
  const isEnded = !!round && isPredictionRoundEnded(round);
  const value = round?.closeTimestamp ?? 0;
  // This ref is used to force a restart of the countdown when the `targetDate` prop changes.
  // React Countdown doesn't restart by default when the prop value updates,
  // so we use this ref to trigger a re-mount by changing the component's `key`.
  // https://www.npmjs.com/package/react-countdown#key
  const keyRef = useRef(1);

  const title = isEnded ? (
    'Coming Soon'
  ) : (
    <Typography variant="h1" color="pink">
      in <PredictionCountDown key={keyRef.current++} value={value} />
    </Typography>
  );

  return (
    <Typography variant="h1">
      <div className="flex gap-2 items-center">
        Next Round{' '}
        {isLoading ? (
          <span className="skeleton-text h-8 max-xl-msq:h-6 w-[60px] max-md-msq:w-[50px]" />
        ) : (
          title
        )}
      </div>
    </Typography>
  );
};
